import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { List, ListSubheader } from '@mui/material';
import itemTypes from '../itemTypes';
import FiltersItem from './filtersItem';
import { filtersPropType } from '../../hooks';

function FiltersList({
  filters, activeFilter, onClick, onDblClick, onDragEnd,
  changeFilterUse, changeFilterOperation, changeFilterValue,
}) {
  const [padded, setPadded] = useState(null);
  const onDragEndHandler = useCallback(
    (item) => {
      onDragEnd(item, padded);
    },
    [onDragEnd, padded],
  );
  const [{
    isOver, isOverCurrent, didDrop,
  }, ref] = useDrop({
    accept: [itemTypes.availableField, itemTypes.filter],
    drop: (item) => onDragEndHandler(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  useEffect(() => {
    if ((!isOver && !isOverCurrent && !didDrop) || (isOver && isOverCurrent && !didDrop)) {
      setPadded(null);
    }
  }, [didDrop, isOver, isOverCurrent]);
  return (
    <List
      sx={{
        border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'auto', flex: '1 1 auto', width: 50,
      }}
      ref={ref}
      component="nav"
      subheader={(
        <ListSubheader component="div" sx={{ bgcolor: 'grey.100' }}>
          Фільтрування
        </ListSubheader>
      )}
      dense
      disablePadding
    >
      {filters.map((f) => (
        <FiltersItem
          key={f.name}
          name={f.name}
          label={f.label}
          use={f.use}
          operation={f.operation}
          value={f.value}
          allowedOperations={f.allowedOperations}
          ctype={f.ctype}
          resource={f.resource}
          isPlural={f.isPlural}
          showControl={f.showControl}
          onClick={onClick}
          onDblClick={onDblClick}
          active={activeFilter === f.name}
          onHover={setPadded}
          padded={padded === f.name}
          errored={f.errored}
          changeFilterUse={changeFilterUse}
          changeFilterOperation={changeFilterOperation}
          changeFilterValue={changeFilterValue}
          choices={f.choices}
          twoControls={f.twoControls}
        />
      ))}
    </List>
  );
}

FiltersList.propTypes = {
  filters: filtersPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  activeFilter: PropTypes.string,
  onDragEnd: PropTypes.func.isRequired,
  changeFilterUse: PropTypes.func.isRequired,
  changeFilterOperation: PropTypes.func.isRequired,
  changeFilterValue: PropTypes.func.isRequired,
};

FiltersList.defaultProps = {
  activeFilter: null,
};

export default FiltersList;
